import React, { useState } from "react";
import { Container, Form, Row, Col, Modal } from "react-bootstrap";
import TalkCmo from "../Images/TalkCmo.webp";
import abcDev from "../Images/DevNew.webp";
import "../Styles/Modal.css";
import "../Styles/Content.css";
import newss from "../Images/TalkDevGif.gif";
import { API_ROOT } from "../apiconfig";

function ModalComp({ show, handleClose }) {
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [policyText, setPolicyText] = useState(
    "*By clicking on the Submit button, you are agreeing with the Privacy Policy with Talk Dev."
  );

  const validateEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(email);
    setIsValidEmail(isValid);
    return isValid;
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    validateEmail();
  };

  const handleEmailBlur = () => {
    validateEmail();
  };

  const resetForm = () => {
    setEmail("");
    setIsValidEmail(true);
    setPolicyText(
      "*By clicking on the Submit button, you are agreeing with the Privacy Policy with Talk Dev."
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateEmail()) {
      try {
        const response = await fetch(`${API_ROOT}/api/subscribe/add`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        });

        if (response.ok) {
          console.log("Subscription successful");
          resetForm();
          setPolicyText("Thank you for subscribing ✅");

          setTimeout(() => {
            resetForm();
          }, 5000);
        } else {
          console.error("Subscription failed");

          if (response.status === 404) {
            setPolicyText("This email is already subscribed ❌");
          }
        }
      } catch (error) {
        console.error("Error sending subscription request:", error);
      }
    } else {
      console.log("Invalid email");
    }
  };

  return (
    <Modal centered show={show} onHide={handleClose} className="subscribePopUp" style={{display:"flex",alignItems:"center"}}>
      <Modal.Header closeButton style={{ backgroundColor: "#662e8b" }}>
        <img src={abcDev} alt="TalkDev Banner" className="subslogo" />
      </Modal.Header>
      <Container className="popupBack">
        <Row>
          <Col md={5} className="laptopmImgback">
            <img
              className="DesktopResponsive mt-1"
              style={{
                width: "100%",
                objectFit: "cover",
                borderRadius: "10px",
              }}
              src="https://enterprisetalk.com/static/media/silverlaptop.f1f016cdf7ed12c1cfe2.png"
              alt="Silver Laptop"
            />
          </Col>
          <Col md={7}>
            <div style={{ textAlign: "center" }}>
              <img
                className="mt-1"
                style={{
                  width: "60%",
                  borderRadius: "10px",
                }}
                src={newss}
                alt="Newsletter Banner"
              />
            </div>
            <Form
              className="px-3"
              controlId="emailInput"
              onSubmit={handleSubmit}
            >
              <Form.Group
                className="px-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Control
                  type="email"
                  placeholder="Email ID"
                  onBlur={handleEmailBlur}
                  autoComplete="off"
                  aria-label="email"
                  data-testid="TextInput"
                  className={`mt-2 py-3 ${isValidEmail ? "" : "is-invalid"}`}
                  value={email}
                  onChange={handleEmailChange}
                />
                <div
                  className="mt-3 px-2 fw-bold text-black"
                  style={{ fontSize: "14px" }}
                >
                  {policyText}
                </div>
                {!isValidEmail && (
                  <div className="invalid-feedback">
                    Please enter a valid email address.
                  </div>
                )}
              </Form.Group>
              <Modal.Footer className="start">
                <button className="SubBtn" type="submit">
                  Submit
                </button>
              </Modal.Footer>
            </Form>
          </Col>
        </Row>
      </Container>
    </Modal>
  );
}

export default ModalComp;
